// ============================================================================
// OBT F2-A — İstemci tarafı doğrulama (paket-yerel)
// ============================================================================
// İstemci doğrulaması backend doğrulamasının YERİNE GEÇMEZ; yalnız erken geri
// bildirim ve gereksiz istek önleme içindir. Backend her alanı ayrıca
// doğrular (extra="forbid", uzunluk, kapsam, yayın ön koşulları).
//
// Sınırlar backend schemas.py ile hizalıdır (campaignEnums.OBT_LIMITS).
// ============================================================================

import { OBT_LIMITS, questionTypeNeedsOptions } from './campaignEnums';

/** Boş/whitespace kontrolü. */
function isBlank(s) {
  return typeof s !== 'string' || s.trim().length === 0;
}

/**
 * Tek bir sorunun istemci doğrulaması.
 * @returns {string[]} hata mesajları (boşsa geçerli)
 */
export function validateQuestion(question, index) {
  const errors = [];
  const n = index + 1;

  if (isBlank(question.question_text)) {
    errors.push(`${n}. soru: soru metni boş olamaz.`);
  } else if (question.question_text.length > OBT_LIMITS.QUESTION_TEXT) {
    errors.push(`${n}. soru: metin ${OBT_LIMITS.QUESTION_TEXT} karakteri aşamaz.`);
  }

  if (questionTypeNeedsOptions(question.question_type)) {
    const options = Array.isArray(question.options) ? question.options : [];
    const nonEmpty = options.filter((o) => !isBlank(o.option_label));
    if (nonEmpty.length === 0) {
      errors.push(`${n}. soru: seçimli soru için en az bir seçenek gerekir.`);
    }
    // Boş seçenek engeli
    if (options.some((o) => isBlank(o.option_label) || isBlank(o.option_value))) {
      errors.push(`${n}. soru: boş seçenek bırakılamaz.`);
    }
    // Tekrarlanan seçenek değeri kontrolü
    const values = nonEmpty.map((o) => o.option_value.trim().toLowerCase());
    if (new Set(values).size !== values.length) {
      errors.push(`${n}. soru: seçenek değerleri tekrar edemez.`);
    }
    // Uzunluk sınırları
    if (options.some((o) => (o.option_value || '').length > OBT_LIMITS.OPTION_VALUE)) {
      errors.push(`${n}. soru: seçenek değeri ${OBT_LIMITS.OPTION_VALUE} karakteri aşamaz.`);
    }
    if (options.some((o) => (o.option_label || '').length > OBT_LIMITS.OPTION_LABEL)) {
      errors.push(`${n}. soru: seçenek etiketi ${OBT_LIMITS.OPTION_LABEL} karakteri aşamaz.`);
    }
  }

  return errors;
}

/** Temel bilgiler doğrulaması. */
export function validateBasics({ title, description, topic, responseDueAt }) {
  const errors = [];
  if (isBlank(title)) {
    errors.push('Bilgi talebi başlığı zorunludur.');
  } else if (title.length > OBT_LIMITS.TITLE) {
    errors.push(`Başlık ${OBT_LIMITS.TITLE} karakteri aşamaz.`);
  }
  if (description && description.length > OBT_LIMITS.DESCRIPTION) {
    errors.push(`Açıklama ${OBT_LIMITS.DESCRIPTION} karakteri aşamaz.`);
  }
  if (topic && topic.length > OBT_LIMITS.TOPIC) {
    errors.push(`Konu ${OBT_LIMITS.TOPIC} karakteri aşamaz.`);
  }
  if (responseDueAt) {
    const due = new Date(responseDueAt);
    if (Number.isNaN(due.getTime())) {
      errors.push('Son cevap tarihi geçersiz.');
    } else if (due.getTime() <= Date.now()) {
      // Backend geçmiş tarihi reddetmez; bu yalnız istemci UX kuralıdır.
      errors.push('Son cevap tarihi gelecekte olmalıdır.');
    }
  }
  return errors;
}

/**
 * Yayın öncesi tam doğrulama.
 * @returns {{ok: boolean, errors: string[]}}
 */
export function validateForPublish({ basics, targets, questions }) {
  const errors = [];

  errors.push(...validateBasics(basics));

  if (!Array.isArray(targets) || targets.length === 0) {
    errors.push('En az bir hedef kişi seçilmelidir.');
  } else if (targets.length > OBT_LIMITS.MAX_TARGETS) {
    errors.push(`En fazla ${OBT_LIMITS.MAX_TARGETS} hedef seçilebilir.`);
  }

  if (!Array.isArray(questions) || questions.length === 0) {
    errors.push('En az bir soru eklenmelidir.');
  } else {
    questions.forEach((q, i) => errors.push(...validateQuestion(q, i)));
  }

  return { ok: errors.length === 0, errors };
}
